import React, { useState, useEffect, useRef, useCallback } from "react";
import sec1 from "../Assests/Diabetes/Sec2_1.png";
import sec2 from "../Assests/Wellness/Sec2-2.png";
import sec3 from "../Assests/Wellness/Sec2_3.png";
import sec4 from "../Assests/Wellness/Sec2_4.png";
import sec5 from "../Assests/Wellness/Sec2_5.png";
import sec6 from "../Assests/Wellness/Sec_6.png";
import Arrow from "../Assests/Diabetes/arrow_1.png";

// Dummy contentData array for demonstration.
// Make sure you have your contentData array defined as needed.
const contentData = 
[
  {
    heading: "Addressing the Root Cause",
    img: sec1,
    content1:
      "Managing diabetes isn’t just about lowering blood sugar; it’s about addressing the underlying metabolic imbalances that cause the disease.",
    content2:
      "The AIWeLL DM™ protocol takes a <span style='color: #DA6E0B'>whole-system approach</span>, going beyond symptom management to target the <span style='color: #DA6E0B'>root causes</span> of metabolic dysfunction-insulin resistance, chronic inflammation, gut microbiome imbalance, and lifestyle-related stressors.",
  },
  {
    heading: "AI Powered Diagnosis",
    img: sec2,
    content1:
      "Not all diabetes cases are the same, yet conventional treatment often takes a one-size-fits-all approach.",
    content2:
      "By analyzing CGM data and blood biomarkers, we differentiate insulin-resistant, inflammatory, gut-dysbiosis-driven, and stress-induced diabetes. This allows us to identify <span style='color: #DA6E0B'>distinct subtypes</span> and deliver personalized, precision-based interventions.",
  },
  {
    heading: "Ayurvedic Doctor Consultation",
    img: sec3,
    content1:
      "True healing goes beyond prescriptions-it requires a personalized, holistic approach that aligns with your body’s unique needs.",
    content2:
      "With the AIWeLL DM™ protocol, you don’t just get a treatment plan-you get one-on-one <span style='color: #DA6E0B'>expert guidance</span> from experienced Ayurveda doctors. Our Ayurveda experts conduct in-depth consultations to understand your body constitution (Prakriti), metabolic imbalances, gut health, and lifestyle factors that influence your condition.",
  },
  {
    heading: "Biomarker Assessment",
    img: sec4,
    content1:
      "Managing diabetes effectively requires real-time insights into how your body responds to food, lifestyle, and interventions.",
    content2:
      "The AIWeLL DM™ protocol integrates <span style='color: #DA6E0B'>Continuous Glucose Monitoring (CGM)</span> and <span style='color: #DA6E0B'>biomarker</span> evaluations to provide a data-driven, personalized approach to metabolic health.",
  },
  {
    heading: "Personalized Recommendations",
    img: sec5,
    content1:
      "Managing diabetes isn’t just about medications or short-term fixes-it requires a comprehensive, personalized strategy that aligns with your body’s unique needs.",
    content2:
      "AIWeLL DM™ protocol creates a 360° wellness plan tailored specifically for you, combining <span style='color: #DA6E0B'>diet, herbal medicines, and lifestyle modifications</span> to optimize metabolic health.",
  },
  {
    heading: "Precision Diet",
    img: sec6,
    content1:
      "Adapting to a new diet doesn’t have to mean extreme restrictions or giving up the foods you love.",
    content2:
      "With the AIWeLL DM™ protocol, we leverage Continuous Glucose Monitoring (CGM) data and Ayurvedic phenotyping to fine-tune your diet-allowing you to make <span style='color: #DA6E0B'>small, sustainable</span> adjustments that deliver <span style='color: #DA6E0B'>big results</span>.",
  },
];

function processHighlight(content) {
  const regex = /<span style=['"]color:\s*#DA6E0B['"]>(.*?)<\/span>/gi;
  return content.replace(regex, (match, innerText) => {
    if (/\band\b/i.test(innerText)) {
      const parts = innerText.split(/\s*\band\b\s*/);
      return parts
        .map((part) => `<span style="color: #DA6E0B; font-weight: bold">${part}</span>`)
        .join(" and ");
    } else {
      return `<span style="color: #DA6E0B; font-weight: bold">${innerText}</span>`;
    }
  });
}

const Page2 = () => {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  // Start auto-scroll (initially only)
  const startAutoScroll = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev < contentData.length - 1 ? prev + 1 : 0));
    }, 4000);
  }, []);

  useEffect(() => {
    // Start auto-scroll on mount
    startAutoScroll();
    return () => clearInterval(intervalRef.current);
  }, [startAutoScroll]);

  // Function to handle manual navigation and disable auto-scroll
  const handleManualNav = (newIndex) => {
    setIndex(newIndex);
    // Disable auto-scroll by clearing the interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleNext = () => {
    // Using handleManualNav to navigate manually; this also disables auto-scroll
    handleManualNav(index < contentData.length - 1 ? index + 1 : 0);
  };

  return (
    <div id="scroll-container" style={{ height: "100vh", overflow: "hidden" }}>
      <div className="page2-container-new">
        <div className="title-container">
          <h2 className="title">Our Unique Solution</h2>
        </div>

        <div className="content-container">
          <div className="page2-left-section">
            <div className="menu">
              {contentData.map((item, i) => (
                <div
                  key={i}
                  className={`menu-item ${i === index ? "active" : ""}`}
                  onClick={() => handleManualNav(i)}
                  style={{ cursor: "pointer" }}
                >
                  {item.heading}
                </div>
              ))}
            </div>
          </div>

          <div className="right-section">
            <img src={contentData[index].img} alt="Solution" className="icon" />
            <p className="description-new">{contentData[index].heading}</p>
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: processHighlight(contentData[index].content1),
              }}
            ></p>
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: processHighlight(contentData[index].content2),
              }}
            ></p>
          </div>
          <button onClick={handleNext} className="arrow-button">
            <img src={Arrow} alt="Next" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Page2;
